<div class="visitor-upfront-registration-action-bar">
    <div class="group">
        <div class="buttons">
            <button mat-icon-button (click)="newVisitReservation()"
                [matTooltip]="'Voranmeldung anmelden' | translate: ['tmc.visitreservation.action.new.tooltip', translationService.language]">
                <sc-icon iconClass="fa-plus"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button (click)="editVisitReservation()"
                [matTooltip]="'Voranmeldung bearbeiten' | translate: ['tmc.visitreservation.action.edit.tooltip', translationService.language]"
                [disabled]="!isEditAllowed">
                <sc-icon iconClass="fa-edit"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button (click)="deleteVisitReservation()"
                [matTooltip]="'Voranmeldung löschen' | translate: ['tmc.visitreservation.action.delete.tooltip', translationService.language]"
                [disabled]="!isDeleteAllowed">
                <sc-icon iconClass="fa-trash"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button (click)="resendInvitation()"
                [matTooltip]="'Einladungs-E-Mail erneut versenden' | translate: ['tmc.visitreservation.action.resendInvitationMail.tooltip', translationService.language]"
                [disabled]="!resendInvitationEnabled">
                <sc-icon iconClass="fa-envelope"></sc-icon>
            </button>

        </div>
    </div>
</div>